'use client';

import { Box, Row, Typography } from '@viewup/ui';
import { XMasRibbon } from 'app/stamp/_features/ui';

type Props = {
  onClick: () => void;
  mainColor: string;
};

export const XmasViewingBanner = ({ onClick, mainColor }: Props) => (
  <Row
    br={8}
    css={{ background: mainColor, cursor: 'pointer' }}
    mt={16}
    onClick={onClick}
    p={12}
    position='relative'
  >
    <Typography color='text.point' fontType='body2.bold'>
      EVENT!{' '}
      <Typography color='system.white' fontType='body2.regular'>
        매일 출석, X-MAS 매일{' '}
        <Typography color='text.point' fontType='body2.bold'>
          2배 적립
        </Typography>{' '}
        이벤트 중!
      </Typography>
    </Typography>
    <Box
      css={{
        position: 'absolute',
        top: -24,
        left: '50%',
        transform: 'translateX(-50%) scale(0.8)',
      }}
    >
      <XMasRibbon color={mainColor} />
    </Box>
  </Row>
);
